import styled from "styled-components";

import { Default } from "Types";
import { Molecules } from "Types/Components";

import AtomLabel from "Components/Atoms/Label";
import AtomTextField from "Components/Atoms/TextField";

export type PropsType = Molecules.FormText;

const Wrap = styled.label<Default>`
   display: flex;
   flex-direction: column;
   row-gap: 10px;
   margin-top: 25px;
   ${({ css }) => css}
`;

export default function MoleculeFormText(props: PropsType) {
   return (
      <Wrap {...props}>
         <AtomLabel></AtomLabel>
         <AtomTextField></AtomTextField>
      </Wrap>
   );
}

MoleculeFormText.Wrap = Wrap;
MoleculeFormText.Label = AtomLabel;
MoleculeFormText.Text = AtomTextField;
